import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Form, FormGroup, PasswordController } from 'components';
import { pillFieldSx } from 'features/auth/containers/SignInForm/styles';
import { useWindowSize } from 'hooks';
import { passwordRules } from 'validations';

import { InputW, SubmitPasswordButton } from './styled';
import { hintsSx } from './styles';
import { useCreatePasswordForm } from './useCreatePasswordForm';

export function CreatePasswordForm({ isEmailExist }: { isEmailExist: boolean }): ReactElement {
  const { isMobile } = useWindowSize();
  const { t } = useTranslation();
  const { control, handleFormSubmit } = useCreatePasswordForm(isEmailExist);

  const handlePasswordFormCLick = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    handleFormSubmit();
  };

  return (
    <Form onSubmit={handlePasswordFormCLick}>
      <FormGroup marginBottom={isMobile ? 32 : 18} row>
        {!isEmailExist && (
          <InputW>
            <PasswordController
              name="password"
              id="password"
              control={control}
              label={t('activateEmployee.passwordPlaceholder')}
              placeholder={t('activateEmployee.passwordPlaceholder')}
              rules={passwordRules}
              maxLength={60}
              hintsSx={hintsSx}
              withAdornment
              sx={pillFieldSx}
            />
          </InputW>
        )}
      </FormGroup>

      <SubmitPasswordButton type="submit" variant="contained" color="info">
        {isEmailExist
          ? t('activateEmployee.activateAccountButton')
          : t('activateEmployee.submitPasswordButton')}
      </SubmitPasswordButton>
    </Form>
  );
}
